import { action } from "mobx";
import AwsS3UploadPartSignedUrlRepository from "~/repository/AwsS3/AwsS3UploadPartSignedUrlRepository";

class AwsS3UploadPartSignedUrlStore {
  /**
   * @property {AwsS3UploadPartSignedUrlRepository|null}
   */
  awsS3UploadPartSignedUrlRepository = null;

  constructor() {
    this.awsS3UploadPartSignedUrlRepository = new AwsS3UploadPartSignedUrlRepository();
  }

  @action
  getOne(data) {
    return this.awsS3UploadPartSignedUrlRepository.fetchOne(data);
  }
}

export default AwsS3UploadPartSignedUrlStore;
